import type { CatalogOf } from '../types';
import type { en } from './en';

export const hi: CatalogOf<typeof en> = {
  header: {
    brand: 'Doc Assist',
  },
  language: {
    label: 'भाषा',
  },
  consult: {
    booked: 'Anzu आपसे {language} में बात करेंगी।',
  },
  languages: {
    en: 'अंग्रेज़ी',
    id: 'बहासा इंडोनेशिया',
    hi: 'हिन्दी',
    zh: 'मंदारिन',
  },
  form: {
    title: 'रोगी की जानकारी',
    sessionActive: 'सत्र सक्रिय',
    name: {
      label: 'पसंदीदा नाम',
      placeholder: 'रोगी का पूरा नाम दर्ज करें',
      required: 'पसंदीदा नाम आवश्यक है',
    },
    dateOfBirth: {
      label: 'जन्म तिथि',
      placeholder: 'जन्म तिथि चुनें',
      required: 'जन्म तिथि आवश्यक है',
      invalid: 'कृपया एक मान्य जन्म तिथि दर्ज करें',
    },
    gender: {
      label: 'जन्म के समय लिंग',
      placeholder: 'जन्म के समय लिंग चुनें',
      male: 'पुरुष',
      female: 'महिला',
      required: 'जन्म के समय लिंग आवश्यक है',
    },
    mode: {
      label: 'मेरी पसंदीदा संवाद विधि है',
      voice: 'आवाज़',
      text: 'टेक्स्ट',
      required: 'संवाद विधि चुनना आवश्यक है',
    },
    start: 'नया सत्र शुरू करें',
  },
  conversation: {
    emptyVoice: 'आपकी बातचीत यहाँ दिखाई देगी',
    emptyText: 'Anzu तैयार हो रही हैं। आप नीचे टाइप करना शुरू कर सकते हैं।',
    typing: 'Anzu टाइप कर रही हैं',
    you: 'आप',
    anzu: 'Anzu',
    placeholder: 'अपना संदेश लिखें...',
    send: 'भेजें',
  },
  session: {
    end: 'सत्र समाप्त करें',
    saving: 'सत्र सहेजा जा रहा है...',
    confirmBody: 'क्या आप वाकई यह सत्र समाप्त करना चाहते हैं? यह कार्रवाई पूर्ववत नहीं की जा सकती।',
    continue: 'सत्र जारी रखें',
  },
  timeout: {
    title: 'सत्र समय समाप्ति चेतावनी',
    inactive: 'आपका सत्र 60 सेकंड से निष्क्रिय है।',
    countdown: 'आपका सत्र {seconds} सेकंड में स्वतः समाप्त हो जाएगा।',
    hint: 'जारी रखने के लिए "सत्र जारी रखें" पर क्लिक करें, या सत्र को स्वतः समाप्त होने दें।',
    endNow: 'अभी समाप्त करें',
  },
  errors: {
    micPermission: 'बातचीत के लिए Anzu को आपके माइक्रोफ़ोन की आवश्यकता है। कृपया अपने ब्राउज़र में माइक्रोफ़ोन की अनुमति दें और लिंक दोबारा खोलें, या फिर से शुरू करके टेक्स्ट चुनें।',
  },
  disclaimer: {
    title: 'AIGP Health प्लेटफ़ॉर्म सामान्य अस्वीकरण',
    important: 'महत्वपूर्ण: AIGP HEALTH प्लेटफ़ॉर्म का उपयोग करने से पहले कृपया यह अस्वीकरण ध्यान से पढ़ें।',
    lead: 'AIGP Health के AI प्लेटफ़ॉर्म "Anzu" का उपयोग करके, उपयोगकर्ता निम्नलिखित को स्वीकार करते हैं और उससे सहमत होते हैं:',
    point1: 'यह प्लेटफ़ॉर्म आपकी जानकारी एकत्र करने के लिए आर्टिफ़िशियल इंटेलिजेंस (AI) का उपयोग करता है।',
    point2: 'AI सिस्टम में दर्ज की गई जानकारी आपकी निर्धारित consultation के समय आपके इलाज करने वाले चिकित्सक को भेजी जाएगी।',
    point3: 'आपकी अपॉइंटमेंट से पहले किसी भी डॉक्टर द्वारा इसे न तो देखा जाएगा, न समीक्षा की जाएगी और न ही उस पर कोई कार्रवाई की जाएगी।',
    point4: 'यह प्लेटफ़ॉर्म चिकित्सा आपात स्थितियों में उपयोग के लिए नहीं है।',
    point5: 'यदि आपको सीने में दर्द, साँस लेने में कठिनाई, अत्यधिक रक्तस्राव, या कोई अन्य गंभीर या जानलेवा स्थिति है, तो अभी सत्र समाप्त करें और तुरंत 000 पर कॉल करें।',
    point6: 'यदि इस प्री-कंसल्ट सत्र के बाद आपकी स्थिति बिगड़ती है, तो आप आपातकालीन चिकित्सा सहायता लेने या अपने स्थानीय अस्पताल से संपर्क करने के लिए सहमत हैं।',
    point7: 'इस प्लेटफ़ॉर्म का उपयोग जारी रखकर, आप पुष्टि करते हैं कि यह कोई चिकित्सा आपात स्थिति नहीं है और आप समझते हैं कि Anzu केवल एक प्री-कंसल्ट उपकरण है।',
    point8: 'जहाँ आपातकालीन देखभाल आवश्यक थी, वहाँ देखभाल में देरी से उत्पन्न परिणामों के लिए AIGP Health कोई ज़िम्मेदारी स्वीकार नहीं करता।',
    cancel: 'रद्द करें',
    agree: 'मैं सहमत हूँ - सत्र शुरू करें',
  },
  farewell: {
    preparing: 'आपका सारांश तैयार किया जा रहा है...',
    preparingHint: 'इसमें बस एक क्षण लगेगा।',
    thanks: 'AIGP Health Doc Assist का उपयोग करने के लिए धन्यवाद',
    loggingOut: 'लॉग आउट हो रहा है...',
  },
};
